import { render, staticRenderFns } from "./ExcSocial.vue?vue&type=template&id=62d669ab&scoped=true&"
import script from "./ExcSocial.vue?vue&type=script&lang=js&"
export * from "./ExcSocial.vue?vue&type=script&lang=js&"
import style0 from "./ExcSocial.vue?vue&type=style&index=0&id=62d669ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d669ab",
  null
  
)

export default component.exports